import React from "react";
import { MemoryGame } from "./MemoryGame";
import { registerGame } from "../common/registry";
import { Game } from "../common/types";

// Memory Game için icon
const MemoryGameIcon: React.ReactNode = (
  <div className="w-full h-full flex items-center justify-center relative">
    <div className="grid grid-cols-2 grid-rows-2 gap-1 w-full h-full p-2">
      <div className="bg-blue-500 rounded-md"></div>
      <div className="bg-green-500 rounded-md"></div>
      <div className="bg-purple-500 rounded-md"></div>
      <div className="bg-yellow-500 rounded-md"></div>
    </div>
  </div>
);

// Memory Game oyununu kaydet
const memoryGame: Game = {
  id: "memory-game",
  name: "games.list.memoryGame.title",
  description: "games.list.memoryGame.description",
  component: MemoryGame,
  icon: MemoryGameIcon,
  category: "puzzle",
};

// Oyunu otomatik kaydet
registerGame(memoryGame);

export { MemoryGame };
export default memoryGame;
